import React, { Component } from 'react';
import Header from './header';
import Sidebar from './sidebar';
import Footer from './Footer';
import StickyNotesContainer from './StickyNotesContainer';

class Base extends Component {
    render() {
        return (
            <React.Fragment>
                <Header 
                    logo='./img/logo-efisco.png' 
                />
                <StickyNotesContainer />
                <div className="container portal-container">
                    <Sidebar />
                    <div className="main-container">
                        {this.props.children}
                    </div>
                </div>
                <Footer/>
            </React.Fragment>
        );
    }
}

export default Base;
